import React, { useState } from 'react'
import { Field } from 'formik'
import { LinearProgress, TextField, Select, MenuItem, InputLabel, FormControl, FormHelperText, Button } from '@material-ui/core'
// import axios from 'axios'
import "../styles/FormPage1.css"
import { KeyboardDatePicker } from '@material-ui/pickers';
// import "react-datepicker/dist/react-datepicker.css";
import { myBucket } from '../services/UploadService'
import { ApiURL } from '../constants/ApiUrl';
import axios from 'axios';


function FormPage1({ errors, touched, setFieldValue, values, appId }) {

    const [Progress1, setProgress1] = useState(0)
    const [Progress2, setProgress2] = useState(0)

    // console.log(values.dob);


    const handleDateChange = (n, val) => {
        console.log(n, "change1")
        const d = new Date();
        setFieldValue("dob", "");
        if (val === null)
            return

        if (val.includes('_'))
            return
        if (d.getFullYear() - n.getFullYear() > 14)
            setFieldValue("dob", n);
        else
            alert("An applicant should be atleast 15 years in age or date is invalid.")


    }

const uploadProfile = async (e) => {
  try {
    const file = e.target.files[0];
    if (!file) return;

    const ext = file.name.split('.').pop().toLowerCase();
    if (!["jpg", "jpeg", "bmp", "png"].includes(ext)) {
      alert("Only JPG, BMP, PNG files allowed");
      return;
    }

    const params = {
      Key: `applications/${appId}/profile.${ext}`,
      ContentType: file.type,
    };

    // 1️⃣ Get signed URL from backend
    const res = await axios.get(
      ApiURL +
        `/api/upload/signed-url?key=${encodeURIComponent(params.Key)}&contentType=${encodeURIComponent(file.type)}`
    );
    const { url } = res.data;
    console.log("Signed URL generated: ", url);

    // 2️⃣ Upload using XHR with progress
    await new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("PUT", url);
      xhr.setRequestHeader("Content-Type", file.type);

      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          const percent = Math.round((event.loaded / event.total) * 100);
          setProgress1(percent); // update your state
        }
      };

      xhr.onload = () => {
        if (xhr.status === 200) resolve(xhr.response);
        else reject(new Error(`Upload failed with status ${xhr.status}`));
      };
      xhr.onerror = () => reject(new Error("Upload failed due to network error"));

      xhr.send(file);
    });

    // 3️⃣ Save public URL
    setFieldValue(
      "profile_image",
      `https://pub-5e98b3129b274a77aa3ee9286a182644.r2.dev/${params.Key}`
    );
    console.log("File uploaded successfully:", params.Key);
  } catch (e) {
    console.error("Upload error (profile):", e);
  }
};

const uploadSign = async (e) => {
  try {
    const file = e.target.files[0];
    if (!file) return;

    const ext = file.name.split('.').pop().toLowerCase();
    if (!["jpg", "jpeg", "bmp", "png"].includes(ext)) {
      alert("Only JPG, BMP, PNG files allowed");
      return;
    }

    const params = {
      Key: `applications/${appId}/sign.${ext}`,
      ContentType: file.type,
    };

    // 1️⃣ Get signed URL from backend
    const res = await axios.get(
      ApiURL +
        `/api/upload/signed-url?key=${encodeURIComponent(params.Key)}&contentType=${encodeURIComponent(file.type)}`
    );
    const { url } = res.data;
    console.log("Signed URL generated: ", url);

    // 2️⃣ Upload using XHR with progress
    await new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("PUT", url);
      xhr.setRequestHeader("Content-Type", file.type);

      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          const percent = Math.round((event.loaded / event.total) * 100);
          setProgress2(percent); // update your state
        }
      };

      xhr.onload = () => {
        if (xhr.status === 200) resolve(xhr.response);
        else reject(new Error(`Upload failed with status ${xhr.status}`));
      };
      xhr.onerror = () => reject(new Error("Upload failed due to network error"));

      xhr.send(file);
    });

    // 3️⃣ Save public URL
    setFieldValue(
      "signature_image",
      `https://pub-5e98b3129b274a77aa3ee9286a182644.r2.dev/${params.Key}`
    );
    console.log("File uploaded successfully:", params.Key);
  } catch (e) {
    console.error("Upload error (sign):", e);
  }
};


    return (
        <div className="formFlexCon">
            <div className="formFlexSubCon">
                <div className="ctrl">
                    <Field name="name" label="Name *" as={TextField} variant="outlined" fullWidth error={touched.name && errors.name} helperText={touched.name && errors.name} />
                </div>
                {/* <Field name="dob" label="Date of Birth *" component={KeyboardDatePicker} variant="outlined" fullWidth  error={touched.dob && errors.dob} helperText={touched.dob && errors.dob} /> */}
                <div className="ctrl">
                    <FormControl variant="outlined" fullWidth error={touched.dob && errors.dob}>
                        {/* <InputLabel id="dobLabel">Date of Birth (dd-mm-yyyy)*</InputLabel> */}
                        {/* <Field as={DatePicker} labelId="dobLabel" label="Date of Birth (dd-mm-yyyy)*"/> */}
                        <KeyboardDatePicker margin="normal" label="Date of Birth (dd/mm/yyyy)*" value={values.dob !== '' ? values.dob : null} format="dd/MM/yyyy" onChange={handleDateChange} error={touched.dob && errors.dob} />
                        <FormHelperText error>{touched.dob && errors.dob}</FormHelperText>
                    </FormControl>
                </div>
                <div className="ctrl">
                    <FormControl variant="outlined" fullWidth error={touched.gender && errors.gender}>
                        <InputLabel id="genderLabel">Gender*</InputLabel>
                        <Field name="gender" labelId="genderLabel" label="Gender*" as={Select} fullWidth>
                            <MenuItem value=''>Select Gender</MenuItem>
                            <MenuItem value='male'>Male</MenuItem>
                            <MenuItem value='female'>Female</MenuItem>
                            <MenuItem value='other'>Other</MenuItem>
                        </Field>
                        <FormHelperText error>{touched.gender && errors.gender}</FormHelperText>
                    </FormControl>
                </div>
                <div className="ctrl">
                    <Button variant="contained" component="label" fullWidth>
                        Applicant Photograph
                        <input name="profile_image" type="file" hidden onChange={uploadProfile} accept="image/*" />
                        <FormHelperText error>{touched.profile_image && errors.profile_image}</FormHelperText>
                    </Button>
                    {values.profile_image !== '' && <a href={values.profile_image} target="_blank" rel="noreferrer">View Uploaded Profile Image</a>}
                    <LinearProgress variant="determinate" value={Progress1} />
                </div>
            </div>
            <div className="formFlexSubCon">
                <div className="ctrl">
                    <FormControl variant="outlined" fullWidth error={touched.blood_group && errors.blood_group}>
                        <InputLabel id="bgLabel">Blood Group *</InputLabel>
                        <Field name="blood_group" labelId="bgLabel" label="Blood Group *" as={Select} fullWidth >
                            <MenuItem value="">Select blood group</MenuItem>
                            <MenuItem value="A+">A+</MenuItem>
                            <MenuItem value="A-">A-</MenuItem>
                            <MenuItem value="B+">B+</MenuItem>
                            <MenuItem value="B-">B-</MenuItem>
                            <MenuItem value="AB+">AB+</MenuItem>
                            <MenuItem value="AB-">AB-</MenuItem>
                            <MenuItem value="O+">O+</MenuItem>
                            <MenuItem value="O-">O-</MenuItem>
                        </Field>
                        <FormHelperText error>{touched.blood_group && errors.blood_group}</FormHelperText>
                    </FormControl>
                </div>
                <div className="ctrl">
                    <Field name="email" label="Email *" as={TextField} variant="outlined" fullWidth error={touched.email && errors.email} helperText={touched.email && errors.email} />
                </div>
                <div className="ctrl">
                    <Field name="phone" label="Mobile Number *" as={TextField} variant="outlined" fullWidth error={touched.phone && errors.phone} helperText={touched.phone && errors.phone} />
                </div>
                <div className="ctrl">
                    <Button variant="contained" component="label" fullWidth>
                        Applicant Signature
                        <input name="signature_image" type="file" hidden onChange={uploadSign} accept="image/*" />
                        <FormHelperText error>{touched.signature_image && errors.signature_image}</FormHelperText>
                    </Button>
                    {values.signature_image !== '' && <a href={values.signature_image} target="_blank" rel="noreferrer">View Uploaded Signature</a>}
                    <LinearProgress variant="determinate" value={Progress2} />
                </div>
            </div>
        </div>
    )
}

export default FormPage1
